export const mappingToolbarPillButtonSx = {
    fontSize: 12,
    textTransform: "none",
    height: 32,
    minWidth: 0,
    px: 1.5,
    borderRadius: 999,
    bgcolor: "grey.50",
    borderColor: "grey.300",
    color: "text.primary",
    boxShadow: "none",
    "&:hover": {
        bgcolor: "grey.100",
        borderColor: "grey.400",
        boxShadow: "none",
    },
};
